module.exports = __webpack_public_path__ + "static/media/in-number-7.5300b988.png";